import React, { useEffect } from 'react'
import { Form, Input, Spin } from 'antd'

import {
    CheckCircleOutlined,
    CloseCircleOutlined,
} from '@ant-design/icons'

import {
    StyledModal,
    ModalTitle,
} from './Charting.styles'

import {
    StyledForm,
    ButtonContainer,
} from './ProviderNoteModal.styles'

import { StyledButton } from '../../Button';

import { useCaseViewContext } from '../../../context';

export const ProviderNoteModal = ({
    onCancel,
    addProviderNote,
    editProviderNote,
    selectedItem,
    modalMode,
    loading
}) => {
    const [form] = Form.useForm()
    const { caseDetails } = useCaseViewContext()

    const handleSubmit = async (params) => {
        const submitFn = !!selectedItem
            ? editProviderNote
            : addProviderNote

        const payload = params

        if (!!selectedItem) {
            payload._id = selectedItem._id
        } else {
            payload.caseId = caseDetails._id
        }

        const success = await submitFn(payload)
        if (success) {
            form.resetFields()
            onCancel()
        }
    }

    const handleCancel = () => {
        form.resetFields()
        onCancel()
    }

    useEffect(() => {
        if (selectedItem) {
            form.setFieldsValue(selectedItem)
        } else {
            form.resetFields()
        }
    }, [selectedItem, form])

    return (
        <StyledModal
            centered
            width={600}
            open={!!modalMode}
            title={!!modalMode && <ModalTitle>{modalMode} Provider Note</ModalTitle>}
            closable={false}
            footer={null}
        >
            <Spin spinning={loading}>
                <StyledForm
                    form={form}
                    layout={"vertical"}
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        label="Title"
                        name="title"
                        rules={[{ required: true, message: 'Please enter a title' }]}
                    >
                        <Input id="provider-note-title-input" />
                    </Form.Item>
                    <Form.Item
                        label="Note"
                        name="content"
                        rules={[{ required: true, message: 'Please enter note content' }]}
                    >
                        <Input.TextArea id="provider-note-content-textarea" autoSize={{ minRows: 6, maxRows: 10 }} />
                    </Form.Item>
                    <ButtonContainer>
                        <StyledButton
                            id="provider-note-cancel-btn"
                            type="button"
                            size="medium"
                            Icon={CloseCircleOutlined}
                            tooltip="Cancel"
                            color="red"
                            onClick={handleCancel}
                        />
                        <StyledButton
                            id="provider-note-submit-btn"
                            type="submit"
                            size="medium"
                            Icon={CheckCircleOutlined}
                            tooltip="Submit"
                        />
                    </ButtonContainer>
                    <Form.Item hidden name='_id' />
                </StyledForm>
            </Spin>
        </StyledModal>
    )
}
